import Geolocator from './geolocator';
export const geolocator = new Geolocator(); // Core geolocation system
import NavInjector from './geolocator-injector';
import log from 'loglevel';
export const setLogLevel = log.setLevel;
export const navInjector = NavInjector; // Builds navigation (possibly footer) UI
window.onload = function() {  // Necessary because nav injected after page loads.
  NavInjector(null, null, {});
};


// WEBPACK FOOTER //
// ./src/scripts/service-with-ui.js